

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// APPROVEHOMESECTION
// APPROVEHOMESECTION


const APPROVEHOMESECTION= createAsyncThunk(
  "approveHomeSection/approveHomeSection",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const approveHomeSectionSlice = createSlice({
  name: "approveHomeSectionSlice",
  initialState: {
    approveHomeSection: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfapproveHomeSection: (state) => {
        state.approveHomeSection.loading = false
        state.approveHomeSection.error = false
        state.approveHomeSection.data = []
        state.approveHomeSection.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(APPROVEHOMESECTION.fulfilled, (state, action) => {
      state.approveHomeSection = {
        ...state.approveHomeSection,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(APPROVEHOMESECTION.pending, (state, action) => {
      state.approveHomeSection = {
        ...state.approveHomeSection,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(APPROVEHOMESECTION.rejected, (state, action) => {
      state.approveHomeSection = {
        ...state.approveHomeSection,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const approveHomeSectionAction = {
    APPROVEHOMESECTION,
};

export { approveHomeSectionAction };
export default approveHomeSectionSlice.reducer;
export const {setInitialStateOfapproveHomeSection} = approveHomeSectionSlice.actions
